/* ==========================================================================
   COLLECTION PAGE
   --------------------------------------------------------------------------
   The page title is data ("The Archive"), so the leading article arrives as
   part of a text node and CSS has nothing to select. Same reason the policy
   pages needed a few lines of script: you cannot style half a string.

   Wrapping is done once, guarded on the marker class, so a re-render or a
   second call cannot nest the span inside itself.
   ========================================================================== */
(function () {
  function liftArticle(el) {
    if (!el || el.querySelector('.hcl-the')) return;

    /* The theme runs the title through <split-words>, which already wraps each
       word in its own span for the fade-up animation. When that is present the
       article is a real element and only needs a class, which is both simpler
       and safer than rewriting text inside something that animates. */
    var words = el.querySelectorAll('split-words .word, .split-words .word');
    if (words.length > 1 && /^the$/i.test(words[0].textContent.trim())) {
      words[0].classList.add('hcl-the');
      return;
    }

    var first = el.firstChild;
    /* Only a leading text node qualifies. If the theme ever wraps the title in
       markup, this leaves it alone rather than rewriting someone else's DOM. */
    if (!first || first.nodeType !== 3) return;
    var m = first.nodeValue.match(/^(\s*)(The)\b(\s*)/i);
    if (!m) return;
    var span = document.createElement('span');
    span.className = 'hcl-the';
    span.textContent = m[2];
    first.nodeValue = first.nodeValue.slice(m[0].length);
    el.insertBefore(span, first);
    if (m[1]) el.insertBefore(document.createTextNode(m[1]), span);
  }

  function sweep() {
    var els = document.querySelectorAll('.banner .heading, .banner h1, .collection-hero__title');
    if (!els.length) return false;
    var done = true;
    els.forEach(function (el) {
      liftArticle(el);
      if (!el.querySelector('.hcl-the')) done = false;
    });
    return done;
  }

  /* <split-words> is a custom element that builds the per-word spans when it
     upgrades, which happens after this deferred script has already run: the
     first attempt saw a bare whitespace text node and correctly did nothing.
     Rather than racing it, retry briefly and stop at the first success. Bounded
     at two seconds so a title that legitimately has no article cannot spin. */
  function run() {
    if (sweep()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (sweep() || ++tries > 20) clearInterval(t);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Archive shop row (24 Oct): pick a size on the card, tap the cart, it lands in the side cart. */
(function () {
/* Phone size sheet (24 Oct): ADD on a compact card opens a small sheet with the sizes and an
   Add to cart button. (The theme's quick-view drawer is hidden on this page by design.) */
var hcaSheet = null, hcaSheetRow = null;
function openSheet(row) {
  hcaSheetRow = row;
  var card = row.closest('.product-card');
  if (!hcaSheet) {
    hcaSheet = document.createElement('div');
    hcaSheet.className = 'hca-sheet';
    hcaSheet.setAttribute('role', 'dialog'); hcaSheet.setAttribute('aria-modal', 'true');
    hcaSheet.innerHTML = '<div class="hca-sheet__scrim" data-hca-close></div><div class="hca-sheet__panel"><button type="button" class="hca-sheet__x" data-hca-close aria-label="Close">&times;</button><p class="hca-sheet__t"></p><p class="hca-sheet__p"></p><div class="hca-sheet__sizes" role="radiogroup"></div><p class="hca-sheet__low" aria-live="polite"></p><button type="button" class="hca-sheet__add" data-hca-sheet-add>Add to cart</button><p class="hca-sheet__msg" aria-live="polite"></p></div>';
    document.body.appendChild(hcaSheet);
  }
  var title = card.querySelector('.product-card__title'), price = card.querySelector('.price');
  hcaSheet.querySelector('.hca-sheet__t').textContent = title ? title.textContent.trim() : '';
  hcaSheet.querySelector('.hca-sheet__p').textContent = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
  hcaSheet.querySelector('.hca-sheet__msg').textContent = '';
  hcaSheet.querySelector('.hca-sheet__low').textContent = '';
  var box = hcaSheet.querySelector('.hca-sheet__sizes'); box.innerHTML = '';
  row.querySelectorAll('[data-hca-size]').forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'hca-sheet__size'; b.textContent = s.textContent;
    b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false'); b.setAttribute('data-id', s.getAttribute('data-hca-size'));
    if (s.getAttribute('data-hca-avail') !== '1') { b.disabled = true; b.title = s.textContent + ' sold out'; }
    if (s.getAttribute('data-hca-low')) b.setAttribute('data-low', s.getAttribute('data-hca-low')); /* low-stock tag (25 Oct) */
    box.appendChild(b);
  });
  hcaSheet.classList.add('is-open'); document.documentElement.classList.add('hca-sheet-open');
  var first = box.querySelector('button:not([disabled])'); if (first) first.focus({ preventScroll: true });
}
function closeSheet() { if (!hcaSheet) return; hcaSheet.classList.remove('is-open'); document.documentElement.classList.remove('hca-sheet-open'); }
document.addEventListener('click', function (e) {
  if (!hcaSheet || !hcaSheet.classList.contains('is-open')) return;
  if (e.target.closest('[data-hca-close]')) { closeSheet(); return; }
  var sz = e.target.closest('.hca-sheet__size');
  if (sz && !sz.disabled) {
    hcaSheet.querySelectorAll('.hca-sheet__size').forEach(function (b) { b.setAttribute('aria-checked', b === sz ? 'true' : 'false'); });
    /* low-stock tag (25 Oct): "Last one in XS" / "Few left in M" */
    var low = sz.getAttribute('data-low');
    hcaSheet.querySelector('.hca-sheet__low').textContent = low ? low + ' in ' + sz.textContent.trim() : '';
    hcaSheet.querySelector('.hca-sheet__msg').textContent = '';
    return;
  }
  var add = e.target.closest('[data-hca-sheet-add]');
  if (!add) return;
  var pick = hcaSheet.querySelector('.hca-sheet__size[aria-checked="true"]');
  if (!pick) { hcaSheet.querySelector('.hca-sheet__msg').textContent = 'Pick a size first.'; return; }
  var id = +pick.getAttribute('data-id');
  closeSheet();
  hcaAdd(id, add, hcaSheetRow);
});
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  function say(row, t) {
    var m = row.parentNode.querySelector('[data-hca-msg]'); if (!m) return;
    m.textContent = t; clearTimeout(m._t); m._t = setTimeout(function () { m.textContent = ''; }, 3200);
  }
  function hcaAdd(id, btn, row2) {
    var t = window.theme, drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.show === 'function' && t && t.routes;
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    btn.setAttribute('aria-busy', 'true');
    if (useDrawer) { drawer.classList.add('hcl-adding'); drawer.show(btn); }
    fetch((t && t.routes ? t.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections.join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status) { if (useDrawer) drawer.close(); say(row2, state.description || 'That size just went.'); return; }
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = state.sections;
        if (t && t.pubsub) t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cart: cart });
        if (!useDrawer) say(row2, 'Added to your cart.');
      });
    }).catch(function () { location.href = '/cart/add?id=' + id + '&quantity=1'; })
      .then(function () { btn.removeAttribute('aria-busy'); if (drawer) drawer.classList.remove('hcl-adding'); });
  }
  window.hcaAdd = hcaAdd;
  function nudge(el) { el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge'); }
  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-hca-size]');
    if (size && !size.disabled) {
      var row = size.closest('[data-hca-buy]');
      row.querySelectorAll('[data-hca-size]').forEach(function (b) { b.setAttribute('aria-checked', b === size ? 'true' : 'false'); });
      return;
    }
    var btn = e.target.closest('[data-hca-add]');
    if (!btn) return;
    var row2 = btn.closest('[data-hca-buy]');
    if (row2.classList.contains('is-locked')) { location.href = row2.getAttribute('data-hca-url'); return; }
    if (row2.classList.contains('is-compact')) { openSheet(row2); return; }
    var picked = row2.querySelector('[data-hca-size][aria-checked="true"]');
    if (!picked) { nudge(row2.querySelector('.hca-buy__sizes')); say(row2, 'Pick a size first.'); return; }
    hcaAdd(+picked.getAttribute('data-hca-size'), btn, row2);
  });
})();

/* Compact rows: if the size track can't give each size ~28px, show only ADD. */
(function () {
  function fit() {
    document.querySelectorAll('[data-hca-buy]').forEach(function (row) {
      var track = row.querySelector('.hca-buy__sizes'); if (!track) return;
      row.classList.remove('is-compact');
      if (window.matchMedia('(max-width: 749px)').matches) { row.classList.add('is-compact'); return; }
      var n = track.querySelectorAll('.hca-buy__size').length || 1;
      if ((track.clientWidth - 6) / n < 28) row.classList.add('is-compact');
    });
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(fit, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('resize', soon); window.addEventListener('load', fit);
})();

/* Drop cards before doors: sizes greyed, cart opens the product page (early access lives there).
   At the drop time the row unlocks itself, no reload needed. The cart still checks server-side. */
(function () {
  function unlock(row) {
    row.classList.remove('is-locked'); row.removeAttribute('data-hca-opens');
    row.querySelectorAll('[data-hca-size]').forEach(function (b) {
      if (b.getAttribute('data-hca-avail') === '1') { b.disabled = false; b.removeAttribute('aria-disabled'); }
    });
    var c = row.querySelector('[data-hca-add]'); if (c) c.setAttribute('aria-label', c.getAttribute('aria-label').replace(/^Open /, 'Add ') + ' to cart');
  }
  function tick() {
    var now = Date.now() / 1000, next = Infinity;
    document.querySelectorAll('[data-hca-buy][data-hca-opens]').forEach(function (row) {
      var at = +row.getAttribute('data-hca-opens');
      if (now >= at) unlock(row); else next = Math.min(next, at);
    });
    if (next !== Infinity) setTimeout(tick, Math.min(60000, Math.max(500, (next - now) * 1000 + 250)));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
})();
